module.exports = __webpack_public_path__ + "img/stats_trustbar.805cee7e.png";